/**
 * 申請種別の URL 表記。旧画面のパス(onboarding / offboarding / transfer / leaves / updates)も
 * `?kind=` に受け付ける(ブックマークと redirect のため)。
 */
import { WF_KINDS } from "./constants";

const ALIAS: Record<string, string> = {
  onboarding: "onboard",
  offboarding: "offboard",
  leaves: "leave",
  updates: "update",
};

/** WF の kind(onboard / offboard / transfer / update / leave / reinstate)に正規化。不明なら null。 */
export function normalizeKind(v: string | null | undefined): string | null {
  if (!v) return null;
  const k = ALIAS[v] ?? v;
  return WF_KINDS.some((w) => w.value === k) ? k : null;
}
